import React from 'react'
import md from 'react-markings'
import { PageTitle } from '@ua-oira/crimson-tide'

const Neat = () =>
  md`
    The University of Alabama is committed to fulfilling the goals of our strategic plan, [_Advancing the Flagship_](https://www.ua.edu/strategicplan/). In order to further address a key goal of the plan to **&quot;Provide opportunities and resources that facilitate work-life balance and enhance the recruitment and retention of outstanding faculty and staff,&quot;** the University partnered with ModernThink to conduct a survey of all faculty and staff regarding their workplace experience. The survey was conducted from March 26 to April 13 of 2018.

    President Stuart Bell and the entire campus leadership team support this effort and are committed to using the results to make improvements where possible.

    * [Read President Bell’s message to the campus community](https://emailtemplates.ua.edu/president/message-from-the-president-17/)

    * [Survey Response Rates](/chime-in-2018/response-rates2018)

    * [Executive Summary and Survey Findings](/chime-in-2018/executive-summary)

    * [Positive Responses By Job Category](/chime-in-2018/positive-responses-by-job-category/)

    It is important to note that this survey is not an end in itself, but a beginning. The University will need further research in the area of work-life balance. In addition, the University plans to repeat this same survey within the next three years to measure change and assess engagement.

    Please refer back to this site for additional information as it becomes available. In the meantime, if you have questions please feel free to contact:

    * Lorne Kuffel, [lkuffel@ua.edu](mailto:lkuffel@ua.edu)
    * Travis Railsback, [trailsback@fa.ua.edu](mailto:trailsback@fa.ua.edu)
    * Jacob Pleitz, [jdpeitz@ua.edu](mailto:jdpeitz@ua.edu)
    * Jon Acker, [acker@ua.edu](mailto:jon.acker@ua.edu)
  `

const Index = () => (
  <div>
    <PageTitle
      name="The University of Alabama Workplace Experience Survey - 2018"
      site="UA"
    />
    <p>
      <h2>
        <em>CHIME IN</em> Workplace Experience Survey Town Hall<br />
      </h2>
      <span>Held October 8th, 12:30 p.m., Graves Hall Rm 118</span>
      <br />
      <a
        alt="About Richard Boyer, Senior Consultant at ModernThink"
        href="/chime-in/2017-Richard-K-Boyer-Bio.pdf"
      >
        Richard Boyer
      </a>, Senior Consultant at ModernThink<br />
      <br />
      <ul>
        <li>
          <a alt="Video of Town Hall" href="https://youtu.be/-W_Englu9r8">
            Watch the Video
          </a>
        </li>
        <li>
          <a
            alt="PowerPoint Presentation - Town Hall"
            href="/chime-in/TownHallPresentation.pptx"
          >
            Download the Presentation (PowerPoint)
          </a>
        </li>
      </ul>
    </p>
    <hr />
    <h2>Your Voice is Important — Please CHIME IN</h2>
    <Video />
    <Neat />
    
    <p>
      View the current <a href="https://oira.ua.edu/chime-in/">2022 Chime In website</a>.
    </p>
  </div>
)

const Video = () => (
  <iframe
    src="https://player.vimeo.com/video/260779685"
    width="640"
    height="360"
    frameborder="0"
    webkitallowfullscreen
    mozallowfullscreen
    allowfullscreen
  />
)

export default Index

//



// WEBPACK FOOTER //
// ./src/pages/index.js